import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Zap, UserCircle, Lock, ShieldCheck, FileKey } from 'lucide-react';
export function PortalHero() {
  return <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-brand-gray" data-id="element-562">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-563">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-564">
          <motion.h1 initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-565">
            Resolve your account, securely and on your schedule.
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-brand-muted" data-id="element-566">
            Access our 24/7 payment portal to manage your balance, set up
            payment plans, or make a quick one-time payment.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-567">
          {/* Quick Pay Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 flex flex-col h-full" data-id="element-568">
            <div className="w-14 h-14 bg-brand-red/10 rounded-xl flex items-center justify-center mb-6" data-id="element-569">
              <Zap className="text-brand-red" size={28} data-id="element-570" />
            </div>
            <h2 className="text-2xl font-bold text-brand-navy mb-2" data-id="element-571">
              Quick Pay
            </h2>
            <p className="text-brand-muted mb-8 flex-grow" data-id="element-572">
              No login required. Enter your account number and make a secure
              payment in under a minute.
            </p>
            <Link to="/portal/quick-pay" className="w-full text-center bg-brand-red hover:bg-red-800 text-white py-3.5 rounded-lg font-bold text-lg transition-colors shadow-sm" data-id="element-573">
              Pay Now
            </Link>
            <div className="mt-4 text-center h-5" aria-hidden="true" data-id="element-574"></div>
          </motion.div>

          {/* Sign In Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 flex flex-col h-full" data-id="element-575">
            <div className="w-14 h-14 bg-brand-navy/10 rounded-xl flex items-center justify-center mb-6" data-id="element-576">
              <UserCircle className="text-brand-navy" size={28} data-id="element-577" />
            </div>
            <h2 className="text-2xl font-bold text-brand-navy mb-2" data-id="element-578">
              Login and Pay
            </h2>
            <p className="text-brand-muted mb-8 flex-grow" data-id="element-579">
              See your balance, set up payment plans, update preferences, and
              view your payment history.
            </p>
            <Link to="/portal/sign-in" className="w-full text-center bg-brand-navy hover:bg-brand-navy/90 text-white py-3.5 rounded-lg font-bold text-lg transition-colors shadow-sm" data-id="element-580">
              Log In
            </Link>
            <div className="mt-4 text-center h-5" data-id="element-581">
              <a href="#" className="text-sm text-brand-navy hover:text-brand-red font-medium transition-colors" data-id="element-582">
                New here? Get started
              </a>
            </div>
          </motion.div>
        </div>

        {/* Trust Strip */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="mt-12 flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-brand-muted font-medium" data-id="element-583">
          <div className="flex items-center gap-2" data-id="element-584">
            <Lock size={16} className="text-green-600" data-id="element-585" />
            Bank-level encryption
          </div>
          <div className="flex items-center gap-2" data-id="element-586">
            <ShieldCheck size={16} className="text-green-600" data-id="element-587" />
            PCI-DSS compliant
          </div>
          <div className="flex items-center gap-2" data-id="element-588">
            <FileKey size={16} className="text-green-600" data-id="element-589" />
            Your information is never shared
          </div>
        </motion.div>
      </div>
    </section>;
}